import React, { useEffect, useRef, useState } from "react";
import { shape, string } from "prop-types";

import styled from "@emotion/styled";

const Wrapper = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  padding: 1rem 1rem 0rem;
`;

const EmailResult = styled.textarea`
  display: block;
  width: 100%;
  padding: 2rem;
  margin-bottom: 3rem;
  box-sizing: border-box;
`;

const EmailExample = styled.div`
  border: 1px solid #5801ff;
  padding: 2rem;
  background-color: #fff;
`;

const HtmlContainer = styled.div`
  width: 100%;
  height: auto;
  max-height: ${({ showHtml }) => (showHtml ? "600px" : "0px")};
  overflow: hidden;
  opacity: ${({ showHtml }) => (showHtml ? "1" : "0")};
  transition: all 1s ease-out;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-family: "Calibre";
  font-weight: 500;
  line-height: 1;
  background-color: #5801ff;
  color: #ffffff;
  font-size: 1rem;
  text-align: center;
  text-transform: uppercase;
  padding: 1rem 2.5rem;
  border: none;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0s;
  margin-top: 3rem;
  &:hover {
    background-color: #d3c3f5;
    color: #5801ff;
  }
`;

const Template = ({
  name,
  job,
  availability,
  phone,
}) => `<table width="320" cellspacing="0" cellpadding="0" border="0">
<tr>
  <td style="vertical-align: top; text-align:left; color:#000000; font-size:16px; line-height:1.5; font-family:'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;">

      <span style="font-weight:600;">
        ${name}
      </span>
      <br/>

      <span>
        ${job}
      </span>
      ${
        typeof availability !== "undefined" && availability !== ""
          ? `<br/><span><i>${availability}</i></span>`
          : ""
      }

  </td>
</tr>

<tr>
  <td style="vertical-align: top; text-align:left; padding-top:8px;">
    <img width="150" height="70" src="https://signature-generator.greenberry.dev/email-animation.gif" alt="Greenberry" style="border:none; display:block;" />
  </td>
</tr>

<tr>
  <td style="vertical-align: top; text-align:left; color:#444444; font-size:16px; line-height:1.5; font-family:'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; padding-top:8px;">

    Maliebaan 50<br/>
    3581 CS Utrecht<br/>
    +31302737424<br/>
    ${typeof phone !== "undefined" && phone !== "" ? `${phone}<br/>` : ""}

    <a target="_blank" href="https://www.greenberry.nl" style="text-decoration:none; color:#5801FF;">
      www.greenberry.nl
    </a>
    <br/><br/>
    <span style="font-size:14px;">
      Digital design inspiratie, industry updates en nieuwtjes in je mailbox?
      <a target="_blank" href="https://greenberry.email-provider.eu/memberforms/subscribe/standalone/form/?a=qpy7ywnxzq&l=ewztevqe2b" style="text-decoration:underline; color:#5801FF;">
        Meld je aan
      </a>
      voor Greenberry's Backend.
    </span>

  </td>
</tr>
</table>

<table cellspacing="0" cellpadding="0" border="0" style="color:#444444; font-family:'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; line-height:1.5; font-size:12px;">
  <tr>
    <td style="height:1em;"></td>
  </tr>
  <tr>
    <td style="font-size:12px;">
      De informatie in dit bericht is vertrouwelijk. Het is daarom niet toegestaan dat u deze informatie openbaar maakt, vermenigvuldigt of verspreidt, tenzij de verzender aangeeft dat dit wel is toegestaan. Als dit e-mailbericht niet voor u bestemd is, vragen wij u vriendelijk maar dringend om het bericht en kopieën daarvan te vernietigen. Dit bericht is gecontroleerd op bekende virussen. Helaas kunnen wij niet garanderen dat het bericht dat u ontvangt volledig en tijdig verzonden is, of tijdig ontvangen wordt en vrij is van virussen of aantasting door derden.
    </td>
  </tr>
</table>
`;

const SignatureFormatter = ({ user }) => {
  const [userInfo, setUserInfo] = useState(user);
  const [htmlShown, setHtmlShown] = useState(false);
  const textAreaRef = useRef(null);
  const signatureElementRef = useRef(null);

  useEffect(() => {
    setUserInfo(user);
  }, [user]);

  const Result = Template(userInfo);

  return (
    <Wrapper>
      <EmailExample
        ref={signatureElementRef}
        dangerouslySetInnerHTML={{ __html: Result }}
      />
      <Button onClick={() => setHtmlShown(!htmlShown)}>Toon html</Button>
      <HtmlContainer showHtml={htmlShown}>
        <EmailResult ref={textAreaRef} readOnly rows="30" value={Result} />
      </HtmlContainer>
    </Wrapper>
  );
};

SignatureFormatter.propTypes = {
  user: shape({
    name: string.isRequired,
    job: string.isRequired,
    availability: string,
    phone: string,
  }).isRequired,
};

export default SignatureFormatter;
